import { Box, Stack } from "@mui/material";
import React from "react";
import { CardData } from "../CardData";
import MediaCard from "../MediaCard";

export default function Home() {
  return (
    <Box sx={{ mt: 5 }}>
      <Stack direction="row" spacing={2}>
        {CardData.map((value, key) => (
          <MediaCard data={value} key={key} />
        ))}
      </Stack>
    </Box>
  );
}
